import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import '@missionlabs/smartagent-app-components/dist/index.css';
import 'typeface-rubik'

ReactDOM.render(<App />, document.getElementById('root'));
